import { createAsyncThunk } from '@reduxjs/toolkit';
import { getGroups, getGroupsTreeForm, getGroupsStyle } from '../../services/api';

export const getGroupsAsync: any | null = createAsyncThunk(
  'groups/getGroups',
  async () => {
    const response = await getGroups();
    return response?.data;
  }
);

export const getGroupsTreeFormAsync: any | null = createAsyncThunk(
  'groups/getGroupsTreeForm',
  async () => {
    const response = await getGroupsTreeForm();
    return response?.data;
  }
);

export const getGroupsStyleAsync: any | null = createAsyncThunk(
  'groups/getGroupsStyle',
  async (_data: any, { getState }) => {
    const state: any = getState();
    const { groupId } = state.common.user.userLogged;
    const response = await getGroupsStyle(groupId);
    return response?.data;
  }
);